import { render, staticRenderFns } from "./register-login.vue?vue&type=template&id=5a62c6ad&"
import script from "./register-login.vue?vue&type=script&lang=js&"
export * from "./register-login.vue?vue&type=script&lang=js&"
import style0 from "./register-login.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports